(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tlb-home-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tlb-home-intro')) {
    customElements.define('tlb-home-intro', class extends HTMLElement {
      connectedCallback() {
        this.mainCta = this.querySelector('[data-home-main-cta]');
        this.sticky = this.querySelector('[data-home-sticky]');
        if (!this.mainCta || !this.sticky) return;
        this.observer = new IntersectionObserver(([entry]) => {
          this.sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
        });
        this.observer.observe(this.mainCta);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlb-newsletter-welcome"]) return;
  try {
    
(() => {
const panel=document.getElementById('tlb-welcome'),gift=document.getElementById('tlb-gift');
if(!panel||!gift||panel.dataset.initialized)return;
panel.dataset.initialized='true';
const key='tlb_bienvenue20_seen_until',pendingKey='tlb_bienvenue20_pending';
let storage=false,pending=false,seen=false;
try{localStorage.setItem('tlb_storage_test','1');localStorage.removeItem('tlb_storage_test');storage=true;seen=Number(localStorage.getItem(key))>Date.now();pending=sessionStorage.getItem(pendingKey)==='1';}catch{}
const remember=()=>{try{localStorage.setItem(key,String(Date.now()+30*86400000));}catch{}};
const excluded=new RegExp('^/(cart|checkouts?|account)(/|$)').test(location.pathname);
const show=()=>{
if(document.visibilityState!=='visible'){document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')show();},{once:true});return;}
if(document.querySelector('dialog[open]:not(#tlb-welcome)'))return;
if(!panel.open)panel.showModal();gift.hidden=true;panel.scrollTop=0;remember();
};
const close=()=>{panel.close();remember();};
panel.querySelector('.tlb-close').addEventListener('click',close);
panel.querySelector('.tlb-later').addEventListener('click',close);
panel.addEventListener('close',()=>{gift.hidden=excluded;});
panel.addEventListener('cancel',remember);
panel.addEventListener('click',e=>{if(e.target===panel){const r=panel.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
gift.addEventListener('click',show);
panel.querySelector('form')?.addEventListener('submit',()=>{try{sessionStorage.setItem(pendingKey,'1');}catch{}});
const copy=panel.querySelector('.tlb-copy');
if(copy)copy.addEventListener('click',async()=>{try{await navigator.clipboard.writeText('DOUCEUR20');copy.textContent=copy.dataset.copied||'Copié !';}catch{const range=document.createRange();range.selectNodeContents(panel.querySelector('.tlb-code'));const selection=window.getSelection();selection.removeAllRanges();selection.addRange(range);}});
gift.hidden=excluded;
const result=panel.querySelector('[data-tlb-result]');
if(pending&&result){show();if(result.dataset.tlbResult==='success'){try{sessionStorage.removeItem(pendingKey);}catch{}}}
else if(new URLSearchParams(location.search).get('tlb_newsletter_preview')==='1'){show();}
else if(storage&&!seen&&panel.dataset.subscribed!=='true'&&!window.Shopify?.designMode&&!excluded){show();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlb-palette-choice"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tlb-palette-choice__card').forEach(function(card) {
    if (card.dataset.previewReady === 'true') return;
    card.dataset.previewReady = 'true';
    var image = card.querySelector('.tlb-palette-choice__image');
    var group = card.querySelector('.tlb-palette-choice__swatches');
    var name = card.querySelector('[data-preview-label]');
    if (!image || !group || !name) return;
    var base = { src: image.getAttribute('src'), srcset:image.getAttribute('srcset'), sizes:image.getAttribute('sizes'), alt:image.getAttribute('alt') };
    var buttons = group.querySelectorAll('[data-preview-src]');
    function preview(button) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.setAttribute('src',button.dataset.previewSrc);
      image.setAttribute('alt',button.dataset.previewAlt || base.alt || '');
      name.textContent = button.dataset.previewName || '';
      name.hidden = false;
      buttons.forEach(function(b){b.setAttribute('aria-pressed',b===button?'true':'false');});
    }
    function restore() {
      image.setAttribute('src',base.src);
      if (base.srcset) image.setAttribute('srcset',base.srcset);
      if (base.sizes) image.setAttribute('sizes',base.sizes);
      image.setAttribute('alt',base.alt || '');
      name.hidden = true;
      buttons.forEach(function(b){b.setAttribute('aria-pressed','false');});
    }
    buttons.forEach(function(b) {
      b.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse'||e.pointerType==='pen')preview(b);});
      b.addEventListener('focus',function(){preview(b);});
      b.addEventListener('click',function(){preview(b);});
    });
    group.addEventListener('pointerleave',function(e){if(e.pointerType==='mouse'||e.pointerType==='pen')restore();});
    group.addEventListener('focusout',function(e){if(!group.contains(e.relatedTarget))restore();});
    var more=group.querySelector('[data-preview-more]');
    if(more) more.addEventListener('click',function(){
      var on=group.classList.toggle('is-expanded');
      more.setAttribute('aria-expanded',on?'true':'false');
      more.textContent=on?'−':'+'+more.dataset.moreCount;
      more.setAttribute('aria-label',on?'Réduire les couleurs':'Afficher les '+more.dataset.moreCount+' autres coloris');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
